import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { noop } from '@prisjakt/ui-base';
import { PRODUCT_ALERT_MODAL_ID } from '../../constants';
import { headerClickEvent } from '../../actions/product';

import ErrorBoundary from '../../../../components/error-boundary';

import { ProductHeaderProps } from './types';

import * as S from './styles-mobile';

const ProductHeaderMobile = (props: ProductHeaderProps) => {
  const dispatch = useDispatch();

  const { title, product, showModal } = props;

  const handleProductActionClick = useCallback(
    (type: string) => {
      dispatch(headerClickEvent(type));
      if (type === 'alert-create') {
        showModal(PRODUCT_ALERT_MODAL_ID);
      }
    },
    [dispatch, showModal]
  );

  if (!product) {
    return null;
  }

  return (
    <S.Header>
      <S.MainSection>
        <ErrorBoundary onError={noop}>
          {product && (
            <>
              {props.currentCampaign ? (
                <S.CampaignBadge
                  campaign={props.currentCampaign}
                  size="large"
                />
              ) : null}
              <S.ProductMedia
                name={product.name}
                media={product.media}
                category={product.category}
              />
            </>
          )}
        </ErrorBoundary>
        <S.DescriptionWrapper>
          <S.Title data-test="ProductTitle">{title}</S.Title>

          <S.ProductActionButtons
            product={product}
            onAction={handleProductActionClick}
            buttonStyle="circle"
            horizontal
          />
        </S.DescriptionWrapper>
      </S.MainSection>
    </S.Header>
  );
};

export default ProductHeaderMobile;
